import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const ContentHubModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "content-hub" */
            './'
        )
    ),
    componentName: 'ContentHub',
});

export default ContentHubModule;
